import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import { BrowserRouter } from "react-router-dom";

import "../src/assets/css/style.css";
import "./index.css";

import reportWebVitals from "./reportWebVitals";
import Routes from "./routes";
import store from "./store";
import { authCheck } from "./store/actions/user";

// Run auth check before rendering
store.dispatch(authCheck());

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ConfigProvider
          theme={{
            token: {
              controlHeight: 36,
              borderRadius: 6,
              fontSize: 14,
              colorPrimary: "#f97316",
            },
          }}
        >
          <Routes />
        </ConfigProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
